import React, { useState, useEffect, useRef } from 'react';
import { FaBell, FaPlus } from 'react-icons/fa';
import { useNotifications } from '../context/NotificationContext';
import Notification from './Notification';
import './NotificationDropdown.css';

const NotificationDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const notificationContext = useNotifications();
  const notifications = notificationContext?.notifications || [];
  const unreadCount = notificationContext?.unreadCount || 0;
  const markAllAsRead = notificationContext?.markAllAsRead || (() => {});
  const createTestNotification = notificationContext?.createTestNotification || (() => {});
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    if (!isOpen && unreadCount > 0) {
      markAllAsRead();
    }
  };

  return (
    <div className="notification-dropdown-container" ref={dropdownRef}>
      <button className="notification-bell-button" onClick={toggleDropdown}>
        <FaBell />
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </button>

      {isOpen && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h3>Notifications</h3>
            <div className="notification-actions">
              <button 
                className="test-notification-btn" 
                onClick={(e) => {
                  e.stopPropagation();
                  createTestNotification();
                }}
                title="Create test notification"
              >
                <FaPlus />
              </button>
              {notifications.length > 0 && (
                <button className="clear-all-btn" onClick={markAllAsRead}>
                  Mark All Read
                </button>
              )}
            </div>
          </div>
          <div className="notification-list">
            {notifications.length === 0 ? (
              <div className="no-notifications">
                No notifications
              </div>
            ) : (
              notifications.map(notification => (
                <Notification
                  key={notification.id}
                  notification={notification}
                />
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown; 